import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import DropDown from 'src/components/design-system/DropDown';
import useReceiptDetails from 'src/hooks/useReceiptDetails';

const CombineGLCodeDropDownCell = (props: GridCellProps) => {
  const { glCodeOptions } = useReceiptDetails();
  const { dataItem, field = '' } = props;
  const dataValue = dataItem[field] || '';

  const handleChange = useCallback(
    (e: DropDownListChangeEvent) => {
      if (props.onChange) {
        props.onChange({
          dataIndex: e.target.value.id,
          dataItem: props.dataItem,
          field: props.field,
          syntheticEvent: e.syntheticEvent,
          value: e.target.value.value,
        });
      }
    },
    [props]
  );

  const completedValue = glCodeOptions.find((glCodeData) => glCodeData.value === dataValue);
  const nonEditableColumns = ['poglCode'];
  const isEditable = dataItem?.isLeastItemNumZero ? true : !nonEditableColumns.includes(field);

  return (
    <GridCellBase {...props}>
      {isEditable ? (
        <DropDown
          onChange={handleChange}
          value={completedValue?.value}
          options={glCodeOptions as any}
        />
      ) : (
        completedValue?.label
      )}
    </GridCellBase>
  );
};

export default CombineGLCodeDropDownCell;
